import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { DataTablesModule } from 'angular-datatables';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { MisdatosComponent } from './components/dashboard/misdatos/misdatos.component';
import { FacturacionesComponent } from './components/dashboard/facturaciones/facturaciones.component';
import { EmpresasComponent } from './components/dashboard/empresas/empresas.component';
import { PagosComponent } from './components/dashboard/pagos/pagos.component';
import { DeclaracionesComponent } from './components/dashboard/declaraciones/declaraciones.component';
import { AdministradoresComponent } from './components/dashboard/administradores/administradores.component';
import { PersonalComponent } from './components/dashboard/administradores/personal/personal.component';
import { DeclaracionComponent } from './components/dashboard/declaraciones/declaracion/declaracion.component';
import { AltasComponent } from './components/dashboard/administradores/solicitudes/altas/altas.component';
import { RepresentantesComponent } from './components/dashboard/administradores/solicitudes/representantes/representantes.component';
import { SolicitudrepComponent } from './components/dashboard/administradores/solicitudes/representantes/solicitudrep/solicitudrep.component';
import { InvitadoComponent } from './components/invitado/invitado.component';
import { PasswordComponent } from './components/password/password.component';
import { AtendidasComponent } from './components/dashboard/administradores/solicitudes/atendidas/atendidas.component';
import { DecenceroComponent } from './components/dashboard/administradores/decencero/decencero.component';
import { AperturaComponent } from './components/dashboard/administradores/apertura/apertura.component';
import { DecenlineaComponent } from './components/dashboard/administradores/decenlinea/decenlinea.component';
import { DecopergobComponent } from './components/dashboard/administradores/decopergob/decopergob.component';
import { DecaceptadasComponent } from './components/dashboard/administradores/decaceptadas/decaceptadas.component';
import { DocumentosComponent } from './components/dashboard/administradores/documentos/documentos.component';
import { DecdeclinadasComponent } from './components/dashboard/administradores/decdeclinadas/decdeclinadas.component';
import { AperturaporempresaComponent } from './components/dashboard/administradores/aperturaporempresa/aperturaporempresa.component';
import { EstablecimientosComponent } from './components/dashboard/administradores/establecimientos/establecimientos.component';
import { DocumentoaltaComponent } from './components/dashboard/administradores/solicitudes/altas/documentoalta/documentoalta.component';
import { AgrdeclaracionComponent } from './components/dashboard/administradores/agrdeclaracion/agrdeclaracion.component';
import { ActempresaComponent } from './components/dashboard/administradores/actempresa/actempresa.component';
import { DecenborradorComponent } from './components/dashboard/administradores/decenborrador/decenborrador.component';
import { ReportesComponent } from './components/dashboard/administradores/reportes/reportes.component';
import { SinfideicomisoComponent } from './components/dashboard/administradores/sinfideicomiso/sinfideicomiso.component';
import { UnlinkComponent } from './components/dashboard/administradores/unlink/unlink.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    MisdatosComponent,
    FacturacionesComponent,
    EmpresasComponent,
    PagosComponent,
    DeclaracionesComponent,
    AdministradoresComponent,
    PersonalComponent,
    DeclaracionComponent,
    AltasComponent,
    RepresentantesComponent,
    SolicitudrepComponent,
    InvitadoComponent,
    PasswordComponent,
    AtendidasComponent,
    DecenceroComponent,
    AperturaComponent,
    DecenlineaComponent,
    DecopergobComponent,
    DecaceptadasComponent,
    DocumentosComponent,
    DecdeclinadasComponent,
    AperturaporempresaComponent,
    EstablecimientosComponent,
    DocumentoaltaComponent,
    AgrdeclaracionComponent,
    ActempresaComponent,
    DecenborradorComponent,
    ReportesComponent,
    SinfideicomisoComponent,
    UnlinkComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    DataTablesModule
  ],
  providers: [],
  schemas: [
    NO_ERRORS_SCHEMA
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
